import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import dayjs from 'dayjs';
import { MediaQuery as MQ } from '../../../media-query';
import CatalogContent from '../../catalog/content';
import AnalysisSpread from './spreads/analysis';
import BottomLineSpread from './spreads/bottom-line';
import CelticCrossSampleSpread from './spreads/celtic-cross-sample';
import CelticCrossSpread from './spreads/celtic-cross';
import HeartbreakSpread from './spreads/heartbreak';
import KarmicLessonsSpread from './spreads/karmic-lessons';
import HoroscopeTarotSpread from './spreads/horoscope-tarot';
import KarmaSpread from './spreads/karma';
import LifeCycleSpread from './spreads/life-cycle';
import MandalaSpread from './spreads/mandala';
import PeaceHarmonySpread from './spreads/peace-harmony';
import PotentialsSpread from './spreads/potentials';
import ReconciliationSpread from './spreads/reconciliation';
import RevelationSpread from './spreads/revelation';
import SelfKnowledgeSpread from './spreads/self-knowledge';
import SoulmateSpread from './spreads/soulmate';
import StarOfDavidSpread from './spreads/star-of-david';
import TimelineSpread from './spreads/timeline';
import TreeOfLifeSpread from './spreads/tree-of-life';
import TwoHeartsSpread from './spreads/two-hearts';
import YesOrNoSpread from './spreads/yes-or-no';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.getJournal();

        this.per_page = MQ.isMobile() ? 8 : 16;

        this.state = {
            items: [],
            page: 1,
            pages: 0,
            total: 0,
            start: 1,
            end: this.per_page,
            view: 'tile',
            sortBy: 'created_unixtime',
            sortDir: 'desc',
            activeDecks: [],
        };
    }

    componentDidMount() {
        this.props.loadDecks();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.view != this.state.view) {
            return true;
        }

        if (nextState.items != this.state.items) {
            return true;
        }

        if (nextProps.decks != this.props.decks) {
            this.setState({
                activeDecks: nextProps.decks.map(deck => deck.code),
            });

            return true;
        }

        if (nextProps.journal != this.props.journal) {
            if (!this.props.journal || nextProps.journal.data != this.props.journal.data) {
                let filtered = nextProps.journal.data;

                filtered = _.sortBy(filtered, this.state.sortBy);

                if (this.state.sortDir == 'desc') {
                    filtered.reverse();
                }

                const pages = Math.ceil(nextProps.journal.count / this.per_page);
                const page = this.state.page <= pages && filtered.length ? this.state.page : pages;
                const start = (page * this.per_page) - (this.per_page - 1);

                filtered = filtered.slice(start - 1, start + (this.per_page - 1));

                const end = filtered.length >= this.per_page ? this.per_page : filtered.length;

                this.setState({
                    items: filtered,
                    page: page,
                    pages: pages,
                    total: nextProps.journal.count,
                    start: start,
                    end: end,
                    view: this.state.view,
                    sortBy: this.state.sortBy,
                    sortDir: this.state.sortDir,
                });

                return true;
            }
        }

        return false;
    }

    render({ loaded }, { items }) {
        if (loaded) {
            if (items && items.length) {
                return (
                    <journal>
                        <h1 className='has-text-center has-text-left-mobile has-margin-50-bottom'>My Journal</h1>
                        {this.renderViewControls()}
                        {this.renderView()}
                        {this.renderFooter()}
                    </journal>
                );
            }

            return (
                <journal>
                    <p className='sale-msg'>
                        Oops, it looks like you don't have any readings yet!<br className='is-hidden-mobile' />
                        <span className='is-visible-mobile'> </span>Try these suggested readings below...
                    </p>
                    <span>
                        <CatalogContent mode='journal' />
                    </span>
                </journal>
            );
        }

        return (
            <journal>
                <h1 className='has-text-center has-margin-50-bottom'>My Journal</h1>
                <h2 className='has-text-center has-text-alto'>Loading…</h2>
            </journal>
        );
    }

    renderView = () => {
        if (this.state.view == 'tile') {
            return (
                <tile-view>
                    <row className='is-wrap'>
                        {_.map(this.state.items, item => (
                            <column className='is-3 is-4-tablet is-12-mobile'>
                                <tile-view-item type={item.category}>
                                    <p>{dayjs.unix(item.created_unixtime).format('M.D.YY')}</p>
                                    <div className='v-center'>
                                        <h5>{item.product_name}</h5>
                                    </div>
                                    {this.renderSpreadOrIcon(item)}
                                    <row>
                                        <column className='is-6'>
                                            <a href={`/report/${item.slug}`}>View</a>
                                        </column>
                                        <column className='is-6 has-text-right'>
                                            <a
                                                href={this.localize(item.product_description.product_url)}
                                                onClick={(e) => this.trackClick('Repeat', e)}
                                            >
                                                Repeat
                                            </a>
                                        </column>
                                    </row>
                                    {this.renderMenu(item)}
                                </tile-view-item>
                            </column>
                        ))}
                    </row>
                </tile-view>
            );
        } else if (this.state.view == 'list') {
            return (
                <list-view>
                    <list-view-controls>
                        <a onClick={() => this.filter(this.state.page, 'created_unixtime')}>
                            {this.renderColumnName('DATE', 'created_unixtime')}
                        </a>
                        <a onClick={() => this.filter(this.state.page, 'product_name')}>
                            {this.renderColumnName('NAME', 'product_name')}
                        </a>
                        <a onClick={() => this.filter(this.state.page, 'category')}>
                            {this.renderColumnName('CATEGORY', 'category')}
                        </a>
                    </list-view-controls>
                    {_.map(this.state.items, item => (
                        <list-view-item>
                            <span>
                                {dayjs.unix(item.created_unixtime).format('M.D.YY')}
                            </span>
                            <span>
                                <a href={this.localize(item.url)}>{item.product_name}</a>
                            </span>
                            <span>
                                {item.category
                                    .replace(/iching/, 'I Ching')
                                    .replace(/\b[a-z]/g, (letter) => (letter.toUpperCase()))
                                }
                            </span>
                            <span>
                                {this.renderMenu(item)}
                            </span>
                        </list-view-item>
                    ))}
                </list-view>
            );
        }

        return null;
    }

    renderViewControls = () => {
        let list_icon = this.state.view == 'list'
            ? 'https://gfx.tarot.com/images/member/journal/grid.svg'
            : 'https://gfx.tarot.com/images/member/journal/grid-inactive.svg';

        let tile_icon = this.state.view == 'tile'
            ? 'https://gfx.tarot.com/images/member/journal/tile.svg'
            : 'https://gfx.tarot.com/images/member/journal/tile-inactive.svg';


        return (
            <div className='journal-view-controls'>
                <a onClick={() => this.setState({ view: 'list' })}>
                    <img src={list_icon} alt='List View' />
                </a>
                <a onClick={() => this.setState({ view: 'tile' })}>
                    <img src={tile_icon} alt='Tile View' />
                </a>
            </div>
        );
    }

    /* eslint-disable complexity */
    renderSpreadOrIcon = (item) => {
        if (item.category == 'tarot') {
            let Spread = null;
            let className = null;
            let type = null;

            if (item.inputs.cards.length == 12) {
                if (item.upc.match(/mandala/)) {
                    className = 'mandala';
                    Spread = MandalaSpread;
                } else {
                    className = 'horoscope-tarot';
                    Spread = HoroscopeTarotSpread;
                }
            } else if (item.inputs.cards.length == 10) {
                if (item.upc.match(/analysis/)) {
                    className = 'analysis';
                    Spread = AnalysisSpread;
                } else if (item.upc.match(/tree-of-life/)) {
                    className = 'tree-of-life';
                    Spread = TreeOfLifeSpread;
                } else {
                    className = 'celtic-cross';
                    Spread = CelticCrossSpread;
                }
            } else if (item.inputs.cards.length == 9) {
                className = 'life-cycle';
                Spread = LifeCycleSpread;
            } else if (item.inputs.cards.length == 8) {
                if (item.upc.match(/soulmate/)) {
                    className = 'soulmate';
                    Spread = SoulmateSpread;
                } else {
                    className = 'yes-or-no';
                    Spread = YesOrNoSpread;
                }
            } else if (item.inputs.cards.length == 7) {
                className = 'potentials';
                Spread = PotentialsSpread;
            } else if (item.inputs.cards.length == 6) {
                if (item.upc.match(/star-of-david/)) {
                    className = 'star-of-david';
                    Spread = StarOfDavidSpread;
                } else {
                    className = 'revelation';
                    Spread = RevelationSpread;
                }
            } else if (item.inputs.cards.length == 5) {
                if (item.upc.match(/breakthrough/)) {
                    className = 'breakthrough';
                    Spread = BottomLineSpread;
                } else if (item.upc.match(/reflection/)) {
                    className = 'daily-reflection';
                    Spread = BottomLineSpread;
                } else if (item.upc.match(/karma/)) {
                    className = 'karma';
                    Spread = KarmaSpread;
                } else if (item.upc.match(/timeline/)) {
                    className = 'timeline';
                    Spread = TimelineSpread;
                } else if (item.upc.match(/reconciliation/)) {
                    className = 'reconciliation';
                    Spread = ReconciliationSpread;
                } else {
                    className = 'bottom-line';
                    Spread = BottomLineSpread;
                }
            } else if (item.inputs.cards.length == 4) {
                className = 'mandala';
                Spread = MandalaSpread;
                if (item.upc.match(/balance/)) {
                    type = 'balance';
                } else if (item.upc.match(/beginnings/)) {
                    type = 'beginnings';
                } else if (item.upc.match(/changes/)) {
                    type = 'changes';
                } else if (item.upc.match(/peace-harmony/)){
                    className = 'peace-harmony';
                    Spread = PeaceHarmonySpread;
                }
            } else if (item.inputs.cards.length == 3) {
                if (item.upc.match(/heartbreak/)) {
                    className = 'heartbreak';
                    Spread = HeartbreakSpread;
                } else if (item.upc.match(/karmic-lessons/)) {
                    className = 'karmic-lessons';
                    Spread = KarmicLessonsSpread;
                } else if (item.upc.match(/self-knowledge/)) {
                    className = 'self-knowledge';
                    Spread = SelfKnowledgeSpread;
                } else {
                    Spread = CelticCrossSampleSpread;
                }
            } else if (item.inputs.cards.length == 2) {
                className = 'two-hearts';
                Spread = TwoHeartsSpread;
            } else if (item.inputs.cards.length == 1) {
                className = 'mandala';
                Spread = MandalaSpread;
                type = 'one-card';
            } else {
                className = 'celtic-cross';
                Spread = CelticCrossSampleSpread;
            }

            if (!_.contains(this.state.activeDecks, item.inputs.deck_code)) {
                item.inputs.deck_code = 'universal_waite';
            }

            return (
                <tarot-report className={className} onClick={() => this.goTo(item.url)}>
                    <tarot-spread>
                        <Spread
                            deck_code={item.inputs.deck_code}
                            cards={item.inputs.cards}
                            result={item.result || null}
                            type={type}
                        />
                    </tarot-spread>
                </tarot-report>
            );
        } else if (item.category == 'iching') {
            const slant = item.upc.match(/love/) ? 'love' : 'general';
            const lines = item.upc.match(/sample/) ? item.inputs.lines : item.result['future-hexagram'].lines;

            return (
                <row className='is-wrap i-ching-result' onClick={() => this.goTo(item.url)}>
                    {lines.reverse().map(line => (this.renderLines(line, slant)))}
                </row>
            );
        }

        return (
            <img
                src={`https://gfx.tarot.com/images/products/${item.upc}/icon.svg`}
                alt={item.product_name}
                className='product-icon'
                onClick={() => this.goTo(item.url)}
            />
        );
    }
    /* eslint-neable complexity */

    renderMenu = (item) => {
        const text = `Run Another ${item.category == 'astrology' ? 'Report' : 'Reading'}`;

        return (
            <journal-item-menu>
                <span>…</span>
                <ul>
                    <li>
                        <a
                            href={this.localize(item.product_description.product_url)}
                            onClick={(e) => this.trackClick(text, e)}
                        >
                            {text}
                        </a>
                    </li>
                    {this.renderUpgrade(item)}
                    {this.renderUpsell(item)}
                    <li>
                        <a href='#' onClick={(e) => this.removeItem(e, item)}>Remove</a>
                    </li>
                </ul>
            </journal-item-menu>
        );
    }

    renderLines = (line, slant, loop) => {
        const filename = this.renderSingleLine(line, loop);

        return (
            <column className='is-12 has-padding-2-bottom'>
                <img
                    src={`https://gfx.tarot.com/images/iching/iching-${slant}/hexagram-lines/${filename}.svg`}
                    alt={filename}
                    className='i-ching-line-thumb'
                />
            </column>
        );
    }

    renderSingleLine = (line, loop) => {
        switch (line) {
            case 6:
                return loop == 1 ? 'solid-line' : 'broken-changing';
            case 7:
                return 'solid-line';
            case 8:
                return 'broken-line';
            case 9:
                return loop == 1 ? 'broken-line' : 'solid-changing';
            default:
                return 'none';
        }
    }

    renderUpgrade = (item) => {
        if (item.upsell_url) {
            const text = `Get Full ${item.category == 'astrology' ? 'Report' : 'Reading'}`;

            return (
                <li>
                    <a
                        href={this.localize(item.upsell_url)}
                        onClick={(e) => this.trackClick(text, e)}
                    >
                        {text}
                    </a>
                </li>
            );
        }

        return null;
    }

    renderUpsell = (item) => {
        if (item.product_upsells.length) {
            const unused = _.find(item.product_upsells, upsell => _.indexOf(this.props.upsells_used, upsell.upc) == -1);
            const text = 'Suggested Reading';

            if (unused) {
                return (
                    <li>
                        <a
                            href={this.localize(unused.url)}
                            onClick={(e) => this.trackClick(text, e)}
                        >
                            {text}
                        </a>
                    </li>
                );
            }
        }

        return null;
    }

    renderFooter = () => {
        if (this.state.items.length) {
            const pgclass = 'is-6 is-12-mobile has-text-right-desktop has-text-right-tablet has-text-center-mobile';

            return (
                <journal-footer>
                    <row className='is-wrap has-margin-20-top'>
                        <column className='is-6 is-12-mobile has-text-center-mobile has-padding-20-bottom-mobile'>
                            Displaying: {this.state.start} - {this.state.end + this.state.start - 1} of&nbsp;
                            {this.state.total} items
                        </column>
                        <column className={pgclass}>
                            Page: {this.renderPageLinks()}
                        </column>
                    </row>
                </journal-footer>
            );
        }

        return null;
    }

    renderPageLinks = () => {
        let delta = 2;
        let range = [];
        let pages = [];
        let l;

        range.push(1);

        for (let i = this.state.page - delta; i <= this.state.page + delta; i++) {
            if (i < this.state.pages && i > 1) {
                range.push(i);
            }
        }

        if (this.state.pages != 1) {
            range.push(this.state.pages);
        }

        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    pages.push(l + 1);
                } else if (i - l !== 1) {
                    pages.push('...');
                }
            }

            pages.push(i);

            l = i;
        }

        return pages.map(page => {
            if (page == '...') {
                return (
                    <a href='#' onClick={(e) => e.preventDefault()} className='active'>
                        {page}
                    </a>
                );
            }

            return (
                <a
                    href='#'
                    onClick={(e) => this.setPage(e, page)}
                    className={page == this.state.page ? 'active' : ''}
                >
                    {page}
                </a>
            );
        });
    }

    renderColumnName = (name, column) => {
        if (this.state.sortBy == column) {
            return `${name} ${this.state.sortDir == 'desc' ? '↓': '↑'}`;
        }

        return name;
    }

    setPage = (e, page) => {
        e.preventDefault();

        if (page != this.state.page) {
            window.scroll({
                top: 51,
                behavior: 'smooth',
            });

            this.filter(page);
        }
    }

    filter = (page, sortBy = null) => {
        const start = (page * this.per_page) - (this.per_page - 1);
        let filtered = this.props.journal.data;
        let sortDir = this.state.sortDir;

        if (sortBy) {
            if (sortBy == this.state.sortBy) {
                sortDir = this.state.sortDir == 'desc' ? 'asc' : 'desc';
            } else {
                sortDir = sortBy != 'date' ? 'asc' : 'desc';
            }
        }

        sortBy = sortBy || this.state.sortBy;

        filtered = _.sortBy(filtered, sortBy);

        if (sortDir == 'desc') {
            filtered.reverse();
        }

        filtered = filtered.slice(start - 1, start + (this.per_page - 1));

        const end = filtered.length >= this.per_page ? this.per_page : filtered.length;

        this.setState({
            items: filtered,
            page: page,
            start: start,
            end: end,
            sortBy: sortBy,
            sortDir: sortDir,
        });
    }

    removeItem = (e, item) => {
        e.preventDefault();

        this.props.updateJournal({ slug: item.slug });

        this.props.routeTo('journal');
    }

    localize = (url) => {
        if (url && typeof url === 'string') {
            return url.replace(/http(s)?:\/\/www.tarot.com/, '');
        }

        return null;
    }

    goTo = (url) => {
        window.location.href = this.localize(url);
    }

    trackClick = (label, e) => {
        e.preventDefault();

        this.props.trackEvent(['Journal', 'Click', label]);
        this.props.trackPromo(['Journal', label]);

        document.location.href = e.target.href;
    }
}

const mapStateToProps = (state) => ({
    journal: state.journal,
    loaded: state.journal && state.journal.loaded,
    upsells_used: state.cookie && state.cookie.upsells_used || [],
    decks: state.decks,
});

const mapDispatchToProps = (dispatch) => ({
    getJournal: (payload) => dispatch({ type: 'journal:get', payload: payload }),
    updateJournal: (payload) => dispatch({ type: 'journal:update', payload: payload }),
    routeTo: (route) => dispatch({ type: 'route:to', payload: route }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (data) => dispatch({ type: 'promo-tracker:recordInternal', payload: data }),
    loadDecks: () => dispatch({ type: 'decks:required'}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
